import { CountriesAlpha2, State } from '@sequencehq/api'
import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import {
  CustomerCustomProperty,
  TaxRegistrationEntry
} from 'Customer/components/CustomerFormFields'
import { atom } from 'jotai'
import {
  stepDataAtomFactory,
  stepValidationAtomFactory
} from '../../../../atoms'

type ApiCustomer = DashboardApi20240730.GetCustomer.GetCustomerResponse

export type CustomerType = 'existing' | 'new'

export type ExistingCustomerFormData = {
  id: string
}

export type ApiContact = ApiCustomer['contacts'][number]
export type Contact = {
  id: string
  name: string
  email: string
  purposes: ApiContact['purposes']
  notificationSubscriptions: ApiContact['notificationSubscriptions']
}
export type NewCustomerFormData = {
  legalName: string
  contacts: Array<Contact>
  address: {
    country: CountriesAlpha2 | ''
    line1: string
    line2?: string
    town: string
    state?: State
    postcode: string
  }
  taxStatus: ApiCustomer['taxStatus'] | ''
  aliases: Array<string>
  label: string
  parentId?: string
  taxRegistrations: Array<TaxRegistrationEntry>
  customProperties: Array<CustomerCustomProperty>
}

export type ReviewCustomerStepData = {
  customerType: CustomerType
  existingCustomer: ExistingCustomerFormData
  newCustomer: NewCustomerFormData
}

export const DEFAULT_NEW_CUSTOMER_DATA: NewCustomerFormData = {
  legalName: '',
  contacts: [],
  address: {
    country: '',
    line1: '',
    line2: '',
    town: '',
    state: undefined,
    postcode: ''
  },
  taxStatus: '',
  aliases: [],
  label: '',
  parentId: undefined,
  taxRegistrations: [],
  customProperties: []
}

/**
 * To be mounted in the task root
 */
export const reviewCustomerAtom = stepDataAtomFactory('REVIEW_CUSTOMER')
export const reviewCustomerStepValidationAtom =
  stepValidationAtomFactory('REVIEW_CUSTOMER')

export const newCustomerValidationAtom = stepValidationAtomFactory(
  'REVIEW_CUSTOMER',
  'newCustomer'
)

/**
 * May be used within the step
 */
export const isValidatingAtom = atom<boolean>(false)
